import { location, onMount, reactive } from 'cdui-js';
import i18n from '../../../../i18n';
import { CurrencyFlag } from '../../../../components/CurrencyFlag';
import method2 from '../../../../assets/deposit/deposit-method-2.svg';
import method3 from '../../../../assets/deposit/deposit-method-3.svg';
import { bootDepositApp, getDepositEntry, type DepositMode } from './appBridge';
import { IconChevronRight } from './icons';
import { warmupDeposit } from './preload';
import { DepositShell } from './Shell';
import { clearFormBlock, depositUrl, readDepositQuery, type Currency } from './shared';
import './deposit.css';

const currencies = (): { key: Currency; label: string }[] => [
  { key: 'HKD', label: i18n.FundH5.CurrencyHkd },
  { key: 'USD', label: i18n.FundH5.CurrencyUsd },
  { key: 'CNY', label: i18n.FundH5.CurrencyCny },
];

export const DepositHome = () => {
  const query = readDepositQuery();
  const state = reactive({
    currency: query.currency,
    accountNum: query.accountNum,
    mode: '' as DepositMode,
  });

  onMount(() => {
    clearFormBlock();
    void (async () => {
      await bootDepositApp();
      state.mode = getDepositEntry().mode;
      if (state.mode === 'virtual' && state.currency === 'CNY') {
        state.currency = 'HKD';
      }
      warmupDeposit(state.currency);
    })();
  });

  const list = () =>
    state.mode === 'virtual' ? currencies().filter((item) => item.key !== 'CNY') : currencies();

  const go = (path: string) => {
    location.routeTo(
      depositUrl(path, {
        currency: state.currency,
        accountNum: state.accountNum,
        payeeBankAccountNum: '',
        payeeBankCode: '',
        payeeBankName: '',
      }),
    );
  };

  return (
    <DepositShell>
      <div class="home">
        <div>
          <div class="section-title">{i18n.H5Deposit.SelectCurrency}</div>
          <div class="currency-row">
            {list().map((item) => (
              <button
                type="button"
                class={`currency-btn${state.currency === item.key ? ' is-on' : ''}`}
                onclick={() => {
                  state.currency = item.key;
                  warmupDeposit(item.key);
                }}
              >
                <CurrencyFlag code={item.key} />
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <div class="section-title">{i18n.H5Deposit.SelectMethod}</div>
          <div class="method-list">
            {/* <div
              class="method-card"
              onclick={() => {
                showToast('敬请期待');
              }}
            >
              <img src={method1} alt="" />
              <div class="method-info">
                <div class="method-title">
                  eDDA快捷入金
                  <span class="badge">最受欢迎</span>
                </div>
                <div class="method-desc">
                  {'支持港币快捷入金，7x24实时转账，5分钟极速到账\n免收手续费，无需在银行操作，无需上传凭证'}
                </div>
              </div>
              <IconChevronRight />
            </div> */}

            <div class="method-card" onclick={() => go('/h5/deposits/bank/step1')}>
              <img src={method2} alt="" />
              <div class="method-info">
                <div class="method-title">{i18n.FundH5.MethodBank}</div>
                <div class="method-desc">{i18n.H5Deposit.MethodBankDesc}</div>
              </div>
              <IconChevronRight />
            </div>

            <div class="method-card" onclick={() => go('/h5/deposits/cheque/step0')}>
              <img src={method3} alt="" />
              <div class="method-info">
                <div class="method-title">{i18n.FundH5.MethodCheque}</div>
                <div class="method-desc">{i18n.H5Deposit.MethodChequeDesc}</div>
              </div>
              <IconChevronRight />
            </div>
          </div>
        </div>
      </div>
    </DepositShell>
  );
};
